export type TransactionModalData = {
  effectiveDate: string | Date;
  expirationDate: string | Date;
  planCode: string | null;
  groupCode: string | null;
  lineOfBusiness: { id: number; label: string; value: string } | null;
};

export const TransactionModalDefaultValues: TransactionModalData = {
  effectiveDate: '',
  expirationDate: '',
  planCode: '',
  groupCode: '',
  lineOfBusiness: null,
};

export const selectFields = ['lineOfBusiness'];

export const maskedInputs = [];
